import { Dispatch, SetStateAction } from "react";
import { Match } from "../../../../requests/matches";
import { DetailedEvent } from "../../../../requests/matchEvents";
import { addOrDeleteItemInSet } from "../../../../utils/addOrDeleteItemInSet";
import { Action, DatabaseAction, ExpandedAction } from "../../Action";
import type { ActionConfig } from "../ActionConfig";
import { NonDatabaseActionActionConfig } from "./NonDatabaseActionActionConfig";

export class OverrideActionConfig extends NonDatabaseActionActionConfig {
  constructor() {
    super(ExpandedAction.override);
  }

  getButtonPhrase = () => "Override";
  isValid = (
    _previousEvents: DetailedEvent[],
    pseudoEventActions: Set<ExpandedAction>,
    _actionConfigs: Record<Action, ActionConfig>
  ) => {
    return !pseudoEventActions.has(ExpandedAction.permanentOverride);
  };
  doAction = async (
    _previousEvents: DetailedEvent[],
    _createEvent: (
      action: DatabaseAction,
      possessionTeamId: number,
      locX: number,
      locY: number
    ) => void,
    _pseudoEventActions: Set<ExpandedAction>,
    setPseudoEventActions: Dispatch<SetStateAction<Set<ExpandedAction>>>,
    _match: Match,
    _actionConfigs: Record<Action, ActionConfig>,
    _locX?: number,
    _locY?: number
  ): Promise<void> =>
    setPseudoEventActions((prevState) =>
      addOrDeleteItemInSet(prevState, ExpandedAction.override)
    );
}
